// 약관 동의 관련 공통 유틸
// - 카카오 본인인증 단계의 개인정보/이용약관/마케팅 동의는 신청서 생성 전이라
//   로컬스토리지에 임시 저장했다가, 신청서 생성 후 PATCH /applications/{id} 로 반영한다.
// - 이후 단계(유의사항, 소송위임/전자서명, 결제 환불규정)는 해당 페이지에서 바로 PATCH 한다.

import Cookies from "js-cookie";
import API_ENDPOINTS from "./api";

// 듀오 사건 id (고정)
export const DUO_LAWSUIT_ID = 3;

// 본인인증 단계 약관 동의 임시 저장 키
const INITIAL_TERMS_STORAGE_KEY = "duo_initial_terms";

/**
 * 카카오 본인인증 단계의 약관 동의값을 로컬스토리지에 저장한다.
 * @param {{ terms?: boolean, privacy?: boolean, marketing?: boolean }} agreements
 */
export const saveInitialTermsToLocal = (agreements = {}) => {
  try {
    const payload = {
      hasAgreedToTermsOfUse: !!agreements.terms,
      hasAgreedToPrivacyCollection: !!agreements.privacy,
      hasAgreedToMarketing: !!agreements.marketing,
    };
    localStorage.setItem(INITIAL_TERMS_STORAGE_KEY, JSON.stringify(payload));
  } catch (e) {
    // 로컬스토리지 사용 불가 환경은 무시 (동의 자체는 서버 PATCH 시 보강)
  }
};

/**
 * 로컬스토리지에 저장된 본인인증 단계 약관 동의값을 반환한다.
 * @returns {{ hasAgreedToTermsOfUse: boolean, hasAgreedToPrivacyCollection: boolean, hasAgreedToMarketing: boolean } | null}
 */
export const getInitialTermsFromLocal = () => {
  try {
    const raw = localStorage.getItem(INITIAL_TERMS_STORAGE_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch (e) {
    return null;
  }
};

/**
 * 본인인증 단계 약관 동의 임시 저장값을 삭제한다.
 */
export const clearInitialTermsFromLocal = () => {
  try {
    localStorage.removeItem(INITIAL_TERMS_STORAGE_KEY);
  } catch (e) {
    // 무시
  }
};

/**
 * PATCH /applications/{id} - 약관 동의 업데이트
 * lawsuitId 는 항상 포함되며(필수), 전달한 필드만 함께 업데이트된다.
 * @param {number|string} applicationId 신청서 id
 * @param {object} fields UpdateTermsDto 의 동의 필드들 (boolean)
 * @returns {Promise<object|null>} 응답 데이터 (실패 시 throw)
 */
export const patchTermsAgreement = async (applicationId, fields = {}) => {
  if (!applicationId) {
    throw new Error("신청서 ID가 없어 약관 동의를 저장할 수 없습니다.");
  }

  const token = Cookies.get(API_ENDPOINTS.COOKIE_CONFIG.KEYS.ACCESS_TOKEN);

  const body = {
    lawsuitId: DUO_LAWSUIT_ID,
    ...fields,
  };

  const response = await fetch(
    `${API_ENDPOINTS.BASE_URL}/applications/${applicationId}`,
    {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      body: JSON.stringify(body),
    },
  );

  if (!response.ok) {
    let message = "약관 동의 저장에 실패했습니다.";
    try {
      const errorData = await response.json();
      message = errorData.message || message;
    } catch (e) {
      // 응답 파싱 실패는 기본 메시지 사용
    }
    throw new Error(message);
  }

  try {
    return await response.json();
  } catch (e) {
    return null;
  }
};
